import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=15f70256&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=15f70256&prod&lang=scss&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=15f70256&prod&scoped=true&lang=css&"
import style2 from "./Menu.vue?vue&type=style&index=2&id=15f70256&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f70256",
  null
  
)

export default component.exports